import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { AnyProductType } from "../../../constants/productTypes";
import { DealerVehicleResultsRoute } from "../../../navigation/DealerRoutes";
import { useRouteParams } from "../../../navigation/useRouteParams";
import { useGetVehiclePartTypes } from "../../../queries/useGetVehiclePartTypes";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { ComboBox } from "../../../ui/ComboBox/ComboBox";
import { Input } from "../../../ui/Input/Input";
import { Spinner } from "../../../ui/Spinner";
import { ChevronRightIcon } from "../../../ui/icons/ChevronRightIcon";
import { WheelIcon } from "../../../ui/icons/WheelIcon";
import { usePlacement } from "./usePlacement";

export const ProductTypeInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const [
    { productType, vehicleSubmodel, vehicleSubmodelTiresizeId },
    { setProduct },
  ] = useSearchForm();
  const params = useRouteParams(DealerVehicleResultsRoute);
  const { data, isLoading, product } = useGetVehiclePartTypes();
  const disabled = !(vehicleSubmodelTiresizeId && vehicleSubmodel);
  const open = Boolean(!productType && vehicleSubmodelTiresizeId && data);

  return (
    <ComboBox
      onSelectOption={(option): void => {
        setProduct((option?.value as AnyProductType) || null);
      }}
      id="product-combo"
      key={params?.productType}
      open={open}
      options={data || []}
      placement={usePlacement()}
    >
      <Input
        after={isLoading ? <Spinner /> : <ChevronRightIcon />}
        aria-label="selectedProductType"
        before={<WheelIcon />}
        disabled={disabled}
        name="product-type"
        placeholder={t("searchForm.selectProductType")}
        readOnly={!!data}
        value={product || ""}
      />
    </ComboBox>
  );
};
